<ng-select class="custom" #searchSelected (change)="searchSelected.blur()"
    [items]="buffer"
    [multiple]="multiple"
    [virtualScroll]="true"
    [loading]="loading"
    [closeOnSelect]="closeOnSelect"
    [searchable]="true"
    [bindLabel]="bindLabel"
    bindValue="id"
    [placeholder]="placeholder"
    [clearable]="clearable"    
    [(ngModel)]="selectedValue"
    notFoundText="Tìm kiếm..."
    (scroll)="onScroll($event)"
    (scrollToEnd)="onScrollToEnd()"
    (change)="selectedItemsEvent($event)">
</ng-select>